import Link from 'next/link';
import MegaMenuDemo from './MegaMenuDemo';

interface NavBarProps {
  styles?: string;
}

const ToolsHeaderDemo = ({ styles }: NavBarProps) => {
  const navBarId: string = 'navbarNav';

  return (
    <nav
      className={`navbar navbar-expand-lg navbar-light ${styles}`}
      role="navigation"
    >
      <Link href="/" legacyBehavior>
        <a className={`navbar-brand`}>
          <img
            src={`${process.env.NEXT_PUBLIC_BASE_URL}/fachhochschule-nordwestschweiz-fhnw-logo.svg`}
            alt="FHNW - Fachhochschule Nordwestschweiz"
            height={40}
            width={173.594}
          />
        </a>
      </Link>

      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target={`#${navBarId}`}
        aria-controls={`${navBarId}`}
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span> Menü
      </button>
      <div className="collapse navbar-collapse" id={`${navBarId}`}>
        <ul className="navbar-nav mr-auto mt-2 mt-md-0">
          <li className="nav-item">
            <a className={`nav-link`} aria-current="page">
              Home
            </a>
          </li>
          <li className="nav-item dropdown">
            <a
              className={`nav-link dropdown-toggle`}
              href="#"
              id="navbarCorporate"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              Single Dropdown
            </a>
            <ul className="dropdown-menu" aria-labelledby="navbarCorporate">
              <li>
                <a className={`dropdown-item`} title="Webdienste">
                  Subitem I
                </a>
              </li>
              <li>
                <a className={`dropdown-item`} title="Tools und Services">
                  Subitem II
                </a>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
            </ul>
          </li>
          <li className="nav-item dropdown has-megamenu">
            <a
              className={`nav-link dropdown-toggle`}
              href="#"
              data-bs-toggle="dropdown"
            >
              Megamenu
            </a>
            <div className="dropdown-menu megamenu" role="menu">
              <MegaMenuDemo title={`Metatitle`} />
            </div>
          </li>
        </ul>
      </div>
      <div className="collapse navbar-collapse d-flex justify-content-end d-none">
        <div className="language-menu border-primary border-end px-4">
          <ul className="navbar-nav mr-auto mt-2 mt-md-0 gap-2">
            <li className="nav-item">
              <a
                href=""
                className={`btn btn-outline-secondary btn-sm bg-primary text-white px-2`}
                aria-current="page"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title="Demonstration purposes only"
              >
                DE
              </a>
            </li>
            <li className="nav-item">
              <a
                href=""
                className={`btn btn-outline-secondary bg-transparent btn-sm px-2`}
                aria-current="page"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title="Demonstration purposes only"
              >
                EN
              </a>
            </li>
            <li className="nav-item">
              <a
                href=""
                className={`btn btn-outline-secondary bg-transparent btn-sm px-2`}
                aria-current="page"
                data-bs-toggle="tooltip"
                data-bs-placement="bottom"
                title="Demonstration purposes only"
              >
                FR
              </a>
            </li>
          </ul>
        </div>

        {/* USER DROPDOWN */}
        <ul className="navbar-nav mr-auto mt-2 mt-md-0 px-3">
          <li className="nav-item dropdown">
            <a
              className="nav-link dropdown-toggle d-flex align-items-center"
              href="#"
              id="navbarDropdown3"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                src={`${process.env.NEXT_PUBLIC_BASE_URL}/assets/img/icons/user.svg`}
                className="rounded-circle"
                height="22"
                alt="Avatar"
                loading="lazy"
              />
            </a>
            <ul
              className="dropdown-menu dropdown-menu-end"
              aria-labelledby="navbarDropdown3"
            >
              <li>
                <a href="" className="dropdown-item" title="Profile">
                  My Profile
                </a>
              </li>
              <li>
                <a href="" className="dropdown-item" title="Settings">
                  Settings
                </a>
              </li>
              <li>
                <a href="" className="dropdown-item" title="Login">
                  Login
                </a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default ToolsHeaderDemo;
